import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import { StyledAnimatedIcon } from "./animated-icon.scss";

const AnimatedIcon = (props) => {
  const { iconAsset, animationDuration, initialOffset, startAnimation } = props;

  return (
    <StyledAnimatedIcon
      className={classnames("animated-icon", { "fall-in-animation": startAnimation })}
      animationDuration={animationDuration}
      initialOffset={initialOffset}
    >
      <AssetComponent image={{ src: iconAsset }} />
    </StyledAnimatedIcon>
  );
};

export default AnimatedIcon;
